const defaultTagData = {
  shareTitle: 'SBS 핫이슈 : 내가 좋아하는 방송 소식만 모아서 빠르게 즐기세요!',
  shareDescription:
    '클립영상, 비하인트 포토, PD노트 등 SBS의 다양하고 핫한 소식을 신속하게 전달해 드립니다.',
  shareImageUrl:
    'https://program-image.cloud.sbs.co.kr/og/2025/sbs_hotissue.png',
  currentUrl: 'https://www.sbs.co.kr/hotissue',
  keywords:
    'SBS,에스비에스,뉸, PD노트, 비하인트 포토, 현장포토, SBS인기가요 포토, 인기가요 포토, SBS예고, 클립영상, SBS예고, 예고, 핫이슈, SBS핫이슈',
};

export default { ...defaultTagData };
